<agr-form-dialog
  *ngIf="formGroup"
  [formGroup]="formGroup"
  (confirm)="save()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--padding-top">
      <mat-label>{{ 'section.name' | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'section.name' | translate }}"
        formControlName="name"
        data-test="section-item__name"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'section.barn' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'section.barn' | translate }}"
        formControlName="barn"
        data-test="section-item__barn"
      >
        <mat-option *ngFor="let barn of barns$ | async" [value]="barn">{{ barn.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'section.surface-area' | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'section.surface-area' | translate }}"
        formControlName="surfaceArea"
        data-test="section-item__surface-area"
      />
    </mat-form-field>
    <span
      *ngIf="formGroup.errors?.surfaceAreaTooLarge"
      class="custom-properties-validation spacing--margin-negative-top spacing--margin-half-left spacing--padding-half-bottom"
    >
      {{ 'section.invalid.section-larger-than-barn' | translate }}
    </span>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'breed' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'breed' | translate }}"
        formControlName="breed"
        data-test="section-item__breed"
      >
        <mat-option *ngFor="let breed of breeds" [value]="breed">{{ breed.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'gender' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'gender' | translate }}"
        formControlName="gender"
        data-test="section-item__gender"
      >
        <mat-option *ngFor="let gender of genders" [value]="gender">
          {{ gender | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'section.reference-value-sheet' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'section.reference-value-sheet' | translate }}"
        formControlName="referenceValueSheet"
        data-test="section-item__reference-value-sheet"
      >
        <mat-option *ngFor="let refvalsheet of refvalsheets$ | async" [value]="refvalsheet">
          {{ refvalsheet.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</agr-form-dialog>
